import { useState, useEffect, useRef } from 'react';
import NextLink from 'next/link';

const makeup_options = [
  {
    label: "Makeup Recommendations",
    description: "Personalized makeup tips.",
    value: "makeup_recommendations",
    // url: "/makeup-recommendations",
    subOptions: [
  { label: "Blush Placement Guide", value: "makeup_recommendations/blush_placement", url: "/makeup-recommendations/blush-placement" },
  { label: "Eyebrow Shaping Guide", value: "makeup_recommendations/eyebrows", url: "/makeup-recommendations/eyebrows" },
  { label: "Eyeliner Placement Guide", value: "makeup_recommendations/eyeliner", url: "/makeup-recommendations/eyeliner" },
  { label: "Face Contour Guide", value: "makeup_recommendations/face_contour", url: "/makeup-recommendations/face-contour" },
  { label: "Nose Contour Guide", value: "makeup_recommendations/nose_contour", url: "/makeup-recommendations/nose-contour" },
  { label: "Shade Match", value: "makeup_recommendations/shade_match", url: "/makeup-recommendations/shade-match" }
    ]
  },
  {
    label: "AI Face Shape Analyzer",
    description: "Identify your face shape with AI.",
    value: "face_analyzer",
    url: "/face_analyzer"
  },
  {
    label: "AI Skintone Analyzer",
    description: "Find your skintone and undertone match.",
    value: "skintone_analyzer",
    url: "/skintone_analyzer"
  },
  {
    label: "AI Eye Shape Analyzer",
    description: "Discover your eye shape for tailored looks.",
    value: "face_analyzer/facial_feature",
    url: "/face_analyzer/eye_shape"
  }
];

const analysis_options = [
  {
    label: "AI Face Analysis",
    description: "Identify your facial features with AI.",
    value: "face_analyzer",
    // url: "/makeup-recommendations",
    subOptions: [
      {
        label: "AI Face Shape Analyzer",
        description: "Identify your face shape with AI.",
        value: "face_analyzer",
        url: "/face_analyzer"
      },      
      {
        label: "AI Eye Shape Analyzer",
        description: "Discover your eye shape for tailored looks.",
        value: "face_analyzer/facial_feature",
        url: "/face_analyzer/eye_shape"
      }   
    ]
  },  
  {
    label: "AI Skintone Analyzer",
    description: "Find your skintone and undertone match.",
    value: "skintone_analyzer",
    url: "/skintone_analyzer"
  },
  { 
    label: "Face Contour Guide", 
    description: "Live contour guides based on your face.",
  value: "makeup_recommendations/face_contour",
  url: "/makeup-recommendations/face-contour"
  },  
  {
    label: "Blush Placement Guide",
    description: "Tailored blush tips for your face shape.",
  value: "makeup_recommendations/blush_placement",
  url: "/makeup-recommendations/blush-placement"
  },
  {
    label: "Eyebrow Shaping Guide",
    description: "Find the best eyebrow shape for your features.",
  value: "makeup_recommendations/eyebrows",
  url: "/makeup-recommendations/eyebrows"
  }
];
const DropdownWithDescription = ({ selectedOption, feature_flag }) => {
  // let higherLevelOption = selectedOption.startsWith("makeup_recommendations") ? "makeup_recommendations" : selectedOption;
  const options = feature_flag == "makeup" ? makeup_options : analysis_options;
  let higherLevelOption;
  if (feature_flag == "makeup") {
    higherLevelOption = selectedOption.startsWith("makeup_recommendations") ? "makeup_recommendations" : selectedOption;
  } else {
    higherLevelOption = selectedOption.startsWith("face_analyzer") ? "face_analyzer" : selectedOption;
  }
  const [isOpen, setIsOpen] = useState(false);
  const [activeOption, setActiveOption] = useState(null);  // Track the option clicked for L2 menu
  const [isSubMenuOpen, setIsSubMenuOpen] = useState(false);
  const dropdownRef = useRef(null); // Create a ref for the dropdown
  const activeLinkClasses = "rounded-md text-indigo-600 dark:text-pink-50 font-semibold bg-gradient-to-r from-rose-50 via-purple-50 to-indigo-50 dark:from-indigo-500 dark:via-purple-500 dark:to-pink-500";
  // bg-blue-100 font-semibold text-blue-600

  const handleSelect = (option) => {
    if (option.subOptions) {
      setActiveOption(option);
      setIsSubMenuOpen(true);
    } else {
      // If there's no sub-options, handle the regular selection
      setIsOpen(false);
      setIsSubMenuOpen(false);
    }
  };

  const handleSubSelect = (subOption) => {
    // setMetricType(subOption.value);
    setIsSubMenuOpen(false);
    setIsOpen(false);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
        setIsSubMenuOpen(false);
      }
    };

    // Attach the event listener
    document.addEventListener('mousedown', handleClickOutside);
    
    // Clean up the event listener on component unmount
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);  

  const selectedOptionObject = options.find(option => option.value == higherLevelOption);

  return (
    <div ref={dropdownRef} className="md:hidden mt-2 px-10 mb-2 relative w-full md:w-64 z-[45]">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center justify-between w-full px-2 py-0.5 text-left bg-base-100 border border-gray-300 rounded-md shadow-sm focus:outline-none"
      >
        <span>{selectedOptionObject ? selectedOptionObject.label : "Select an Option"}</span>
        <svg
          className={`w-3 h-3 transition-transform transform ${isOpen ? 'rotate-180' : 'rotate-0'}`}
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7"></path>
        </svg>
      </button>

      {isOpen && !isSubMenuOpen && (
        <div className="absolute mt-1 bg-base-100 dark:bg-slate-700 border border-gray-300 rounded-md shadow-lg"
        style={{ width: 'calc(100% - 5rem)'}}>
          {/* {options.map((option, index) => (
            <div
              key={index}
              className={`px-4 py-2 cursor-pointer ${option.value === selectedOption ? 'bg-gray-100 dark:bg-base-100' : ''}`}
              onClick={() => handleSelect(option)}
            >
              <div className='flex flex-row justify-between items-center'>
              <div>
              <div className="font-semibold">{option.label}</div>
              <div className="text-sm text-gray-500 dark:text-gray-300">{option.description}</div>
              </div>
              {option.subOptions && (
                <svg
                  className="w-4 h-4 ml-2 text-gray-500"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7"></path>
                </svg>
              )}
              </div>              
            </div>
          ))} */}
{options.map((option, index) => (
  option.subOptions ? (
    <div
      key={index}
      className={`px-4 py-2 cursor-pointer ${option.value == higherLevelOption ? 'bg-gray-100 dark:bg-base-100' : ''}`}
      onClick={() => handleSelect(option)}
    >
      <div className='flex flex-row justify-between items-center'>
        <div>
          <div className="font-semibold">{option.label}</div>
          <div className="text-sm text-gray-500 dark:text-gray-300">{option.description}</div>
        </div>
        {option.subOptions && (
          <svg
            className="w-4 h-4 ml-2 text-gray-500"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7"></path>
          </svg>
        )}
      </div>
    </div>
  ) : (
    <NextLink href={option.url} key={index} className={`block px-4 py-2 cursor-pointer hover:bg-gray-100 dark:hover:bg-slate-600 ${option.value == higherLevelOption ? 'bg-gray-100 dark:bg-base-100' : ''}`}>
        <div className="font-semibold">{option.label}</div>
        <div className="text-sm text-gray-500 dark:text-gray-300">{option.description}</div>
    </NextLink>
  )
))}
        </div>
      )}

      {isSubMenuOpen && activeOption && (
        <div className="absolute mt-1 bg-base-100 dark:bg-slate-700 border border-gray-300 rounded-md shadow-lg w-full mr-4"
        style={{ width: 'calc(100% - 5rem)'}}> 
          {/* {activeOption.subOptions.map((subOption, index) => (
            <div
              key={index}
              className="px-4 py-2 cursor-pointer"
              onClick={() => handleSubSelect(subOption)}
            >
              <div className="font-semibold">{subOption.label}</div>
            </div>
          ))} */}
          {/* <div className="px-4 py-2 font-bold text-lg border-b border-gray-200">
            {activeOption.label}
          </div> */}
          {activeOption.subOptions.map((subOption, index) => (
            <NextLink
            href={subOption.url}
            key={index}
            >
            <div

              className={`mx-2 ${index == 0 ? "mt-2" : ""} px-2 py-2 cursor-pointer transition-colors ${
                subOption.value == selectedOption // Assuming this is the selected option
                  ? activeLinkClasses // Styling for selected option
                  : 'hover:bg-gray-100 dark:hover:bg-slate-600'
              }`}
              onClick={() => handleSubSelect(subOption)}
            >
              <div>{subOption.label}</div>
            </div>
            </NextLink>
          ))}        
          <div
            className="px-4 py-2 cursor-pointer text-blue-500"
            onClick={() => setIsSubMenuOpen(false)}
          >
            Back to Main Menu
          </div>
        </div>
      )}
    </div>
  );
};

export default DropdownWithDescription;
